import React from 'react';
import { Typography } from "@mui/material";
import i18next from "../../i18n/i18n";
import useStyles from "../../style/js-style/components/common/TitleWithIconStyle";
import { Skeleton } from "@mui/material";
import clsx from "clsx";
import EAColorIcon from './EAColorIcon';

const TitleIconAndNotification = ({icon, notificationCounter}) => {
  const { classes } = useStyles();

  return (
    <div
      style={{
        position: "relative",
        marginRight: notificationCounter !== 0 ? "5px" : "",
      }}
    >
      {icon ? <EAColorIcon
        icon={icon}
        className={classes.icon}
        wrapperClass={classes.iconWrapper}
        width={"20px"}
        height={"20px"}
        svgStyle={{position: 'relative', top: "2px"}}
      />: <></>}
      {notificationCounter !== 0 && (
        <div className={classes.notificationCounter}>{notificationCounter}</div>
      )}
    </div>
  );
};

const TitleResult = ({ noResult, isLoading, resultCount, totalCount }) => {
  const { classes } = useStyles();
  return (
    <>
      {!noResult && <div className={classes.separator} />}
      {isLoading ? (
        <Skeleton
          variant="rect"
          width={50}
          height={12}
          className={classes.resultCount}
          animation="wave"
        />
      ) : (
        !noResult && (
          <>
            <span className={classes.resultCount}>
              {resultCount}&nbsp;
            </span>
            <span className={classes.resultCount}>
              {resultCount > 1 ? i18next.t("results") : i18next.t("result")}&nbsp;
            </span>
            {totalCount !== undefined && resultCount !== totalCount && (
              <span className={clsx(classes.resultCount, classes.totalCount)}>
                {i18next.t("outOf")}  {totalCount}
              </span>
            )}
          </>
        )
      )}
    </>
  );
};
/**
 * Title block with icon & result's counter for sheet-pages
 *
 * @param title
 * @param icon string : icon's url
 * @param resultCount
 * @param totalCount
 * @param isLoading
 * @param noResult
 * @param otherProps
 */
const TitleWithIcon = ({
  title,
  icon,
  resultCount,
  totalCount,
  isLoading = false,
  noResult = false,
  notificationCounter = 0,
  disabled,
  ...otherProps
}) => {
  const { classes } = useStyles();

  return (
    <Typography
      variant="h2"
      className={clsx({
        [classes.title]: true,
        [classes.disabledTitle]: disabled,
      })}
      {...otherProps}
    >
      <TitleIconAndNotification icon={icon} notificationCounter={notificationCounter} />
      {title}
      <TitleResult
        noResult={noResult}
        isLoading={isLoading}
        resultCount={resultCount}
        totalCount={totalCount}
      />
    </Typography>
  );
};
export default TitleWithIcon;
